export default {
  namespaced: true,
  hanwha_camera: {
    title: "Hanwha Câmera | Hanwha Câmeras",
    hanwha: 'hanwha',
    name: "nome",
    channel: "canal",
    type: "tipo",
    ip: "IP",
    class: "classe",
    encryption: "criptografia",
    poe: "tem POE?",
    poe_port: "POE porta",
    http_port: "http porta",
    https_port: "https porta",
    port: "porta",
    port_type: "tipo de porta",
    rtsp_port: "RTSP porta",
    serial_number: "número de série",
    user: "usuário",
    dvr_validation: "você precisa selecionar um DVR",
    device_information: "Informações sobre o dispositivo",
    confirm_delete: "Tem a certeza de que pretende apagar a câmara '%camera%'?",
    state: 'Estado',
    fisheye: 'Fisheye',
    send_to_seproban: 'Enviar para SEPROBAN',
    group: 'Conjunto',
    user_id: 'ID do usuário',
    username: 'Nome de Usuário',
    user_level: 'Nível de usuário',
    password: 'Senha',
    viewer_access: 'Acesso do visualizador',
    password_confirm: 'Confirmar senha para salvar alterações',
    change_password: 'Alterar a senha',
    current_password: 'Senha atual',
    new_password: 'Nova Senha',
    confirm_new_password: 'Confirmar nova senha',
    protocol: "Protocolo",
    local_ip: "IP local",
    model: "Modelo",
    group_id: 'ID do grupo'
  },
};
